import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=b520168e&scoped=true&"
import script from "./simple.vue?vue&type=script&lang=js&"
export * from "./simple.vue?vue&type=script&lang=js&"
import style0 from "./simple.vue?vue&type=style&index=0&lang=css&"
import style1 from "./simple.vue?vue&type=style&index=1&id=b520168e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b520168e",
  null
  
)

export default component.exports